export function setUserFormState(state, payload) {
  switch (payload) {
    case('ca'):
      state.userForm.state = state.ca.state[Math.floor(Math.random() * state.ca.state.length)];
      break;
    case ('fr'):
      state.userForm.state = state.fr.state[Math.floor(Math.random() * state.fr.state.length)];
    break;
    case('it'):
      state.userForm.state = state.it.state[Math.floor(Math.random() * state.it.state.length)];
     break;
    case('es'):
      state.userForm.state = state.es.state[Math.floor(Math.random() * state.es.state.length)];
     break;
    case('de'):
      state.userForm.state = state.de.state[Math.floor(Math.random() * state.de.state.length)];
      break;
    case('pt'):
      state.userForm.state = state.pt.state[Math.floor(Math.random() * state.pt.state.length)];
     break;
    case('fi'):
      state.userForm.state = state.fi.state[Math.floor(Math.random() * state.fi.state.length)];
      break;
    case('pl'):
      state.userForm.state = state.pl.state[Math.floor(Math.random() * state.pl.state.length)];
     break;
    case('ch'):
      state.userForm.state = state.ch.state[Math.floor(Math.random() * state.ch.state.length)];
      break;
    case('at'):
      state.userForm.state = state.at.state[Math.floor(Math.random() * state.at.state.length)];
     break;
    case('dk'):
      state.userForm.state = state.dk.state[Math.floor(Math.random() * state.dk.state.length)];
      break;
    case('no'):
      state.userForm.state = state.no.state[Math.floor(Math.random() * state.no.state.length)];
     break;
    case('nz'):
      state.userForm.state = state.nz.state[Math.floor(Math.random() * state.nz.state.length)];
     break;
    case('se'):
      state.userForm.state = state.se.state[Math.floor(Math.random() * state.se.state.length)];
      break;
    case('sa'):
      state.userForm.state = state.sa.state[Math.floor(Math.random() * state.sa.state.length)];
      break;
    case('be'):
      state.userForm.state = state.be.state[Math.floor(Math.random() * state.be.state.length)];
      break;
    case('sv'):
      state.userForm.state = state.sv.state[Math.floor(Math.random() * state.sv.state.length)];
     break;
    case('au'):
      state.userForm.state = state.au.state[Math.floor(Math.random() * state.au.state.length)];
      break;
    case('gb'):
      state.userForm.state = state.gb.state[Math.floor(Math.random() * state.gb.state.length)];
     break;
    case('ie'):
      state.userForm.state = state.ie.state[Math.floor(Math.random() * state.ie.state.length)];
      break;
    case('cz'):
      state.userForm.state = state.cz.state[Math.floor(Math.random() * state.cz.state.length)];
     break;
    case('hr'):
      state.userForm.state = state.hr.state[Math.floor(Math.random() * state.hr.state.length)];
      break;
    case('hu'):
      state.userForm.state = state.hu.state[Math.floor(Math.random() * state.hu.state.length)];
      break;
    case('gr'):
      state.userForm.state = state.gr.state[Math.floor(Math.random() * state.gr.state.length)];
     break;
    case('my'):
      state.userForm.state = state.my.state[Math.floor(Math.random() * state.my.state.length)];
      break;
    case('nl'):
      state.userForm.state = state.nl.state[Math.floor(Math.random() * state.nl.state.length)];
      break;
  }
}
